const errorMap = {
  user_exists: "Пользователь с таким логином уже существует"
};
export function mapErrorCode(code) {
  return errorMap[code] || code;
}
